import * as React from 'react';
import { Button, Grid } from '@mui/material';
import PocketBase from 'pocketbase';
import NavigateBackScaffold from 'app/components/scaffold/NavigateBackScaffold';
import { pocketBase } from 'config';

import firebaseData from './../../core/firebase/dfiav-app-default-rtdb-export.json';
import { AppUserModel } from 'features/app_user/data/AppUserModel';

export interface FirebaseDb {
    users: AppUserModel[]
    backup: any
    companyData: any
    currentAppVersion: any
    currentAppVersionWeb: any
    deletedUsers: any
    invoices: any
    mailingList: any
    windowsUsers: any
}

const defaultPw = 'DfiAV2025#VPC#Default'
var isInit = false
const sumUsers = Object.entries((firebaseData as any as FirebaseDb).users).length

const MigrateFirebase: React.FC = () => {

    const [go, setGo] = React.useState(false);
    const [mCount, setMCount] = React.useState(0);

    const startMigrate = React.useCallback(async () => {
        let u = 0
        const pb = new PocketBase(pocketBase.url);

        const users = (firebaseData as any as FirebaseDb).users
        const backups = (firebaseData as any).backups

        console.log('startMigrate', { users })

        for (const user of Object.entries(users)) {
            if (u > 10) {
                // break;
            }
            const fbId = user[0] as string
            const uD = user[1] as AppUserModel
            const record = await pb.collection('users').create({
                ...Object.fromEntries(Object.entries(uD).filter(([key, value]) => key !== "id")),
                password: defaultPw,
                passwordConfirm: defaultPw,
                emailVisibility: true,
                customCreatedDate: (uD.customCreatedDate ?? 0) > 0 ? uD.customCreatedDate : (uD.created ?? 0)
            }).catch((error) => {
                console.log(error)
                return
            });

            // appData
            if (record?.id && uD.appData) {

                for (const aD of Object.entries(uD.appData)) {
                    console.log(record?.id, aD)
                    const newAppDataUser = await pb.collection('appData').create({ ...aD[1], title: aD[0] }).catch((error) => { console.log(error) });
                    if (newAppDataUser?.id) {
                        await pb.collection("users").update(record?.id, {
                            // append single id
                            "appData+": newAppDataUser.id,
                        })
                    }
                }
            }

            // backups
            if (record?.id && backups[fbId]?.appData) {
                const bckappData: any = backups[fbId]?.appData
                // console.log(bckappData)

                for (const baD of Object.entries(bckappData)) {
                    console.log(record?.id, baD)
                    const newAppDataBackupUser = await pb.collection('appDataBackup').create({ ...(baD[1] as any), title: baD[0] }).catch((error) => { console.log(error) });
                    if (newAppDataBackupUser?.id) {
                        await pb.collection("users").update(record?.id, {
                            // append single id
                            "backups+": newAppDataBackupUser.id,
                        })
                    }
                }
            }

            // stateLicenses
            if (record?.id && uD.stateLicenses) {
                const stateLicensesData: any = uD.stateLicenses
                console.log(stateLicensesData)
                const newStateLic = await pb.collection('stateLicenses').create(stateLicensesData).catch((error) => { console.log(error) });
                if (newStateLic?.id) {
                    await pb.collection("users").update(record?.id, {
                        // append single id
                        "stateLicenses": newStateLic.id,
                    })
                }
            }

            setMCount(u + 1)

            u += 1
        }
    }, [])

    React.useEffect(() => {
        if (!go && !isInit) {
            isInit = true
            setGo(true)
            // startMigrate()
        }
    }, [go])

    return (
        <NavigateBackScaffold actions={<></>} title={'Migrieren'}>
            <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '50vh' }}>
                <Button onClick={() => startMigrate()}>Migrate</Button>
                <div>{mCount} / {sumUsers}</div>
            </Grid>
        </NavigateBackScaffold>
    );
};

export default MigrateFirebase;
